import { Component, AfterViewInit, OnDestroy } from '@angular/core';
import { LocalizationService } from '@services/localization.service';
import { TranslateService } from '@services/translate.service';
import { ApiService } from '@services/api.service';
import { environment } from '@environments/environment';
import { UiHelper } from '@app/helpers/ui.helper';

@Component({
  selector: 'register-component',
  templateUrl: '../sharedTemplates/register-success.component.html',
})
export class RegisterSuccessComponent implements AfterViewInit, OnDestroy {
  constructor(private _LocalizationService: LocalizationService, private _TranslateService: TranslateService, private _ApiService: ApiService, public _UiHelper: UiHelper) {}

  ngAfterViewInit() {
    try {
      let scrollcord;
      scrollcord = document.getElementById('ScrollingTop');
      setTimeout(() => {
        if (scrollcord != null) {
          scrollcord.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest',
          });
        }
        if (environment.product === 'p1012') {
          this._UiHelper.registerShow();
          const element2 = document.querySelector('#login-p1002') as HTMLElement;
          if (element2) {
            element2.style.display = 'none';
          }
        }
      }, 500);
    } catch (e) {
      console.warn('İtem not found.');
    }
  }
  ngOnDestroy(): void {
    if (environment.product === 'p1012') {
      this._UiHelper.registerSecret();
      const element = document.querySelector('#login-p1002') as HTMLElement;
      if (element) {
        element.style.display = 'flex';
      }
    }
  }
}
